<template>
  <div></div>
</template>

<script>
import { apiGetOpenId, apiGetUserInfo, apiGetAppUserInfo, apiGetInfo_userId } from '@/api/dq';
import { authLogin } from './hooks'
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {

  computed: {
    userId() {
      return this.$store.state.account.userId
    }
  },
  data() {
    return {
      WXcode: '',
    };
  },
  methods: {
    async getWXCode() {
      if (isWechat()) {
        // wx84a082d6e1aaaa1a
        let weChatOfficialAccountType = this.$route.query.weChatOfficialAccountType == 2 ? '2' : '1'
        localStorage.setItem('weChatOfficialAccountType',weChatOfficialAccountType)
        let appid = weChatOfficialAccountType == '2' ? 'wxf91f646263070b5f' : 'wx6291bd6ded26851f'
        let WXcode = this.getUrlCode().code; //是否存在code
        let local = window.location.href;
        if (WXcode && this.$route.path.includes('_dev')) {
          let queryArr = []
          for (const key in this.$route.query) {
            queryArr.push(`${key}=${this.$route.query[key]}`)
          }
          let queryStr = queryArr.join('&')
          window.location.replace(`http://wicmp-sit.wandawic.com/h5-app-sh/?code=${WXcode}&state=STATE#/dq/auth?${queryStr}`)
          return
        }
        if (WXcode == null || WXcode === '') {
          //不存在就打开上面的地址进行授权
          window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`)
        } else {
          this.WXcode = WXcode;
          let openId = await apiGetOpenId(this.WXcode);
          if (openId) {
            localStorage.setItem('dq_openId', openId);
          }
          openId = localStorage.getItem('dq_openId');
          let res = await apiGetUserInfo(openId);
          authLogin(res)
        }
      } else {
        let res = await apiGetInfo_userId(this.userId)
        console.log('res', res);
        authLogin(res)
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      let url = location.search;
      let theRequest = new Object();
      if (url.indexOf('?') != -1) {
        var str = url.substr(1);
        var strs = str.split('&');
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
      return theRequest;
    },
  },
  mounted() {
    this.getWXCode();
  },
};
</script>
